export default {
      id: "shtormtech-usage",
      viewBox: "0 0 100 26",
      url: "assets/" + "sprite.svg#shtormtech-usage",
      toString: function () {
        return this.url;
      }
    }